export default {
  gutterBottom: {
    marginBottom: 8,
  },
  body1: {
    fontSize: 16,
  },
};
